import axios from "@/plugins/axios"
import type { Pagination } from "@/types/common.type"
import type { StockCheckDetail } from "@/types/stock-check.type"

export interface ListRequest {
  page: string | null
  perPage: string | null
  customerCode: string | null
  status: string | null
}

export interface ConfirmRequest {
  stockCheckProducts: {
    productId: number
    stock: number
    reproductionAvailability: string
    reproductionQuantity: number | null
    reproductionDays: number | null
  }[]
}

async function get(id: number): Promise<StockCheckDetail> {
  const response = await axios.get<StockCheckDetail>(`/stock_check_requests/${id}`)
  return response.data
}

async function list(request: ListRequest): Promise<Pagination<StockCheckDetail>> {
  const response = await axios.get<Pagination<StockCheckDetail>>("/stock_check_requests", {
    params: request,
  })
  return response.data
}

async function confirm(id: number, request: ConfirmRequest): Promise<StockCheckDetail> {
  const response = await axios.post(`/stock_check_requests/${id}/confirm`, request)
  return response.data
}

const stockInquiryService = {
  get,
  list,
  confirm,
}

export default stockInquiryService
